<template>
  <div class="bar-menssagem">
    <h4 class="title">Mensagens do leiloeiro</h4>
    <div ref="chatContainer" class="chat-container">
      <div v-if="mensagens">
        <div v-for="msg in mensagens.slice().sort((a, p) => p.id - a.id)"
             :class="`q-message ${usuario.id == msg.usuario_id ? 'q-message-sent' : 'q-message-received'}`">
          <div class="q-message-container row-chat items-end no-wrap">
            <div class="box-message">
              <div class="q-message-text">
                <div class="q-message-name">{{ msg.nm_apelido }}</div>
                <span class="q-message-text-content">
                  <div>{{ msg.nm_mensagem }}</div>
                  <div v-if="msg.nm_path" style="text-align: end">
                    <a :href="msg.nm_path_completo" target="_blank" rel="noopener noreferrer">Abrir anexo</a>
                  </div>
                  <div class="q-message-stamp">{{ msg.data }}</div>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="chat-send" v-show="paramsite_chatcomprador && paramsite_chatcomprador.bn == true">
      <!--comentado envio de mensagem pelo arrematante -->
      <span>
        <input type="text" class="chat-message input-manual" v-model="mensagemEnviar" :placeholder="descMsg"
               @keyup.enter="enviaMensagem">
        <button @click="enviaMensagem" class="send-message btn-lance">Enviar</button>
      </span>
    </div>
  </div>
</template>
<script>

export default {
  name: 'Mensagem',
  props: ['mensagens', 'usuario', 'paramsite_chatcomprador'],
  data() {
    return {
      mensagemEnviar: '',
      reverse: [],
      descMsg: 'Digite aqui sua mensagem...',
      loteId: this.$route.params.idlote,
    }
  },
  methods: {
    enviaMensagem() {
      const chatContainer = this.$refs.chatContainer
      const msg = this.mensagemEnviar
      const hostName = location.protocol + "//" + window.HOSTNAME;
      if (msg != '') {
        fetch(`${hostName}/leilao/envia-mensagem`, {
            params: {
              mensagem_chat: msg,
              lote_id: this.loteId,
              origem_mensagem: 1
            }
          })
          .then((res) => {
            if (!res.ok) {
              throw new Error(`HTTP error! Status: ${res.status}`);
            }
            return res.json();
          })
          .then(function (response) {
            if (response.erro == true) {
              alert(response.msg_erro);
              return false;
            }

            if (!response) {
              alert("Não foi possível enviar sua mensagem.");
              return false;
            }
            chatContainer.scrollTop = chatContainer.scrollHeight;
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.descMsg = 'por favor insira uma mensagem aqui...'
        this.mensagemEnviar = ''
      }

      this.mensagemEnviar = ''
    }
  }
}
</script>
<style scoped>
.chat-bloqueado {
  background-color: #e0e0e0;
}

.bar-menssagem {
  background: #f9f9f9;
}

.title {
  text-align: left;
  color: #67302b !important;
  font-weight: 700 !important;
  font-size: 20px !important;
//background: #fff; padding: 4px 0;
  margin: 0 0 1px !important;
}

.q-message {
  margin-bottom: 8px;
}

.items-end {
  -ms-flex-align: end;
  align-items: flex-end;
}

.no-wrap {
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.row-chat {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.q-message-name {
  font-size: small;
  font-weight: 700;
  margin-bottom: 6px;
}

.q-message-received .q-message-name {
  color: #000;
}

.q-message-sent .q-message-name {
  color: #fff;
}

.q-message-text:last-child {
  min-height: 48px;
}

.q-message-received .q-message-text {
  color: #c9e2ea;
  border-radius: 5px 5px 5px 0;
}

.q-message-text {
  background: currentColor;
  padding: 8px;
  line-height: 1.2;
  word-break: break-word;
  position: relative;
  transform: translateZ(0);
}

.q-message-received .q-message-text:last-child:before {
  right: 100%;
  border-right: 0 solid transparent;
  border-left: 8px solid transparent;
  border-bottom: 8px solid currentColor;
}

.q-message-received .q-message-stamp {
  position: absolute;
  top: 4px;
  right: 7px;
}

.q-message-sent .q-message-stamp {
  position: absolute;
  top: 4px;
  left: 7px;
  color: #fff;
}

.q-message-text:last-child:before {
  content: "";
  position: absolute;
  bottom: 0;
  width: 0;
  height: 0;
}

.q-message-received .q-message-text-content {
  color: #000;
}

.q-message-stamp {
  color: #131313;
  margin-top: 4px;
  opacity: .6;
}

.q-message-sent .q-message-container {
  -ms-flex-direction: row-reverse;
  flex-direction: row-reverse;
}

.q-message-sent .q-message-name {
  text-align: right;
}

.q-message-sent .q-message-text {
  background: #1d1d1d;
}

.q-message-sent .q-message-text {
  color: #e0e0e0;
  border-radius: 5px 5px 0 5px;
}

.text-white {
  color: #fff !important;
}

.q-message-sent .q-message-text:last-child:before {
  left: 100%;
  border-left: 0 solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #1d1d1d;
}

.q-message-text:last-child:before {
  content: "";
  position: absolute;
  bottom: 0;
  width: 0;
  height: 0;
}

.box-message {
  width: 100%;
}

.chat-container {
  padding: 20px;
  overflow: auto;
  height: 182px;
}

.chat-send {
  background: #efefef;
  width: 100%;
  padding: 5px;
}

.chat-message {
  width: 80%;
  border: 1px solid #e6e6e6;
}

.send-message {
  width: 19%;
  cursor: pointer;
}

::-webkit-scrollbar {
  width: 12px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
}

@media (max-width: 480px) {
  .chat-message {
    width: 70%;
  }

  .send-message {
    width: 30%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Mensagem.vue